import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { reactLocalStorage } from '@src/utils/localStorage';

import reduxWrapper from '@src/store';
import * as actions from '@src/store/actions';
import * as selectors from '@src/store/selectors';
import { defaultActionCalls } from '@src/router/ssr';
import { SSR_PAGE_COURSE } from '@src/router/hydrate';
import { getApiData, getPageTimeoutData } from '@src/utils/deprecatedCommon';
import { sentGTMViewItem } from '@src/utils/gtag';

import CoursePage from '@src/components/course';

const Course = () => {
	const router = useRouter();
	const dispatch = useDispatch();
	const currentCourse = useSelector(selectors.getCurrentCourse);
	const { courseId, created_at, previewToken } = router.query;

	useEffect(() => {
		if (!previewToken) {
			reactLocalStorage.remove('previewToken');
		}
		// hardcode for otto2, please refer to TC-5705 or ask Yoru for detail.
		if (courseId === 'uA9hfpqy') {
			dispatch(actions.historyPushCall('/course/openeye'));
		} else {
			dispatch(
				actions.getCurrentCourseCallUpdate({
					courseId,
					created_at,
					preview: !!previewToken,
					previewToken,
				}),
			);
		}
	}, []);

	useEffect(() => {
		if (currentCourse?.id) {
			sentGTMViewItem(currentCourse);
			dispatch(actions.courseViewRecordCall({ courseId: currentCourse.id }));
			dispatch(
				actions.getCourseDiscussionsBeforeCall({
					course_id: currentCourse.id,
					page: 0,
					pageSize: 5,
				}),
			);
			dispatch(
				actions.getCourseDiscussionsCall({
					course_id: currentCourse.id,
					data: {
						created_at,
					},
				}),
			);
			dispatch(
				actions.getCourseRatingCall({
					course_id: currentCourse.id,
					data: {
						created_at,
					},
				}),
			);
			dispatch(
				actions.getPropagandaReviewCall({
					courseId: currentCourse.id,
				}),
			);
			dispatch(
				actions.getCourseCertificateCall({
					courseId: currentCourse.id,
					createCertificateIfNotFound: false,
				}),
			);
			dispatch(
				actions.getCourseAnnouncementsCall({
					course_id: currentCourse.id,
					data: {
						created_at,
					},
				}),
			);
			dispatch(
				actions.getCourseViewCall({
					page: 0,
					page_size: 10,
				}),
			);
		}
	}, [currentCourse?.id]);

	return <CoursePage />;
};

export const getServerSideProps = reduxWrapper.getServerSideProps(
	async ctx => {
		const { req, store, query } = ctx;
		const { ssrHeaders } = getApiData(req);
		const { courseId, created_at, previewToken } = query;

		const time = 3000;
		const pageTimeout = setTimeout(() => {
			const pageTimeoutData = getPageTimeoutData({ req, time });

			if (pageTimeoutData) {
				store.dispatch(
					actions.sendBugMsgCall({ msg: JSON.stringify(pageTimeoutData) }),
				);
			}
		}, time);

		store.dispatch(actions.setSSRPage(SSR_PAGE_COURSE));

		console.time('SSR');

		const success = await new Promise(resolve => {
			const unsubscribe = store.subscribe(() => {
				const state = store.getState();
				const defaultActionDone = defaultActionCalls.actionDone(ctx);
				let currentCourseState = selectors.getCurrentCourseGeneralState(state);
				if (previewToken) {
					currentCourseState = selectors.getCurrentCourseState(state);
				}
				const currentCourse = selectors.getCurrentCourse(state);

				if (defaultActionDone && currentCourseState === 'FAIL') {
					// eslint-disable-next-line no-param-reassign
					ctx.res.statusCode = 404;
					clearTimeout(pageTimeout);
					resolve(unsubscribe);

					return;
				}

				if (
					currentCourse?.id &&
          defaultActionDone &&
          currentCourseState !== 'IDLE' &&
          currentCourseState !== 'LOADING'
				) {
					clearTimeout(pageTimeout);
					console.timeEnd('SSR');
					resolve(unsubscribe);
				}
			});

			defaultActionCalls.actionCall(ctx);

			if (previewToken) {
				store.dispatch(
					actions.getCurrentCourseCall({
						courseId,
						ssrHeaders,
						created_at,
						preview: !!previewToken,
						previewToken,
					}),
				);
			} else {
				store.dispatch(
					actions.getCurrentCourseGeneralCall({
						courseId,
						ssrHeaders,
					}),
				);
			}
		});

		success();
	},
);

export default Course;
